module.exports = __webpack_public_path__ + "img/Gstar-black.48ade1fb.png";